import axios from 'axios'
import { APP_CONFIG } from '../constants/services'
import CoreServices from './coreServices'

class AppConfigServices extends CoreServices {
  async getTurnServer(token) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/turn-server`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })

      let data = await response.data.data

      return data
    } catch (error) {
      let { response } = error
      return { error: response?.data?.error || error }
    }
  }

  async getConfig() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/app-config`)

      let data = await response.data

      return data
    } catch (error) {
      let { response } = error
      return { error: response?.data?.error || error }
    }
  }

  async getPage(slug, locale = 'en') {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/pages/${slug}?locale=${locale}`)

      let data = await response.data

      return data
    } catch (error) {
      let { response } = error
      return { error: response?.data?.error || error }
    }
  }

  async getCountries() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/countries`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new AppConfigServices(APP_CONFIG.BASE)
